import { FirebaseConnection } from './FirebaseConnection';
import { FirestoreCollection } from './FirestoreCollection';
import { DataCallback } from '../DataCallback';
import { FirestoreRepository } from './FirestoreRepository';

export class FunctionsRepository extends FirestoreRepository {
  static readonly COLLECTION_NAME = 'functions';

  private _collection = new FirestoreCollection(this.con.firebase.firestore().collection(FunctionsRepository.COLLECTION_NAME));

  public constructor(private con: FirebaseConnection) {
    super();
  }

  get collection(): any {
    return this._collection;
  }
}
